module.exports = __webpack_public_path__ + "static/media/reverse1.9c1bd185.svg";